<template>
  <div id="activityChecking" style="min-height: calc(100% - 130px);min-width: 900px;position: relative;">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/systemSetupList/systemSetup' }">系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>活动复盘设置</el-breadcrumb-item>
      </el-breadcrumb>
    <div class="page">
      <!-- 设置表头 -->
      <!-- <div class="headerBorder"> -->
        <div>
          <div style="font-size: 18px;margin-bottom: 30px;">
            设置活动复盘信息
          </div>
          <el-row>
            <el-col :span="24">
              <div class="fontback">
                基本字段
              </div>
              <div style="margin-left: 20px;margin-top: 10px;">
                <span v-for="(item,index) in orderProduct" :key='index' style="width: 175px;display: inline-block;">
                  <span @mouseover="iconShowTrue(index,item.fieldRequired)" @mouseout="iconShowFalse(index,item.fieldRequired)">
                    <el-checkbox :label="item.fieldname" style="margin-bottom: 10px;width: 100px;" v-show="checkboxShow[index]"
                      v-model="basicField[index]" :disabled="jbDisabled == 1" @change="checkboxEmpty(item.fieldname,index,item.id,item.fieldRequired)"></el-checkbox>
                      <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"  v-model="fieldname[index]" placeholder="请输入内容" maxlength='10' size="small" style="width:115px;" v-show="inputShow[index]"></el-input>
                      <span v-show="iconShow[index]" style="color: #108cee;cursor: pointer;background-color: white;z-index: 9999;position: absolute;">
     									  <i class="el-icon-edit-outline" style="margin-right: 5px;margin-left: 5px;margin-left: 5px;" @click="InputShow(index,item.fieldname)"></i>
                        <i class="el-icon-delete" slot="reference" @click="referenceDelete(index)"></i>
                        <el-popover placement="top" width="200" v-model="popovervisible[index]">
                        <span><i class="el-icon-warning" style="color: #ffaa16;margin-top: 10px;"></i></span>
                        <span style="margin-left: 9px;color: #585858;font-weight: bold;">你确定要删除该字段吗？</span>
                        </br>
                        <span style="color: #db4757;margin-left: 23px;">删除后录入的信息会被删除</span>
                        <div style="text-align: right; margin-top: 15px;">
                          <el-button type="primary2" size="small" @click="deleteProductField(index,1,item.id)" style="margin-left: 5px;">确 定</el-button>
                          <el-button size="small" @click="deleteProductField(index,2)" type="TheCustom">取 消</el-button>
                        </div>
                        </el-popover>
     								  </span>
                    <span v-show="succShow[index]" style="color: #108cee;cursor: pointer;">
   									 <i class="el-icon-check" style="margin-right: 5px;margin-left: 5px;" @click="productField(index,1,item.id,item.fieldClassify)"></i>
   									 <i class="el-icon-close" @click="productField(index,2)"></i>
   								  </span>
                  </span>
                </span>
                <span style="color: #108cee;cursor: pointer;">
                  <i class="el-icon-circle-plus-outline" style="margin-right: 10px;width: 14px;height: 14px;" v-show="addFieldnameHidden && jbDisabled == 2" @click="addProductField()"></i>
                  <span v-show="addFieldnameHidden && jbDisabled == 2" @click="addProductField()">新增</span>
                  <el-input autofocus onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="addFieldname" maxlength='10' placeholder="请输入内容" size="small" style="width:115px;" v-show="addFieldnameShow"></el-input>
                  <i class="el-icon-check" style="margin-right: 5px;margin-left: 5px;" @click="addFieldnamesucc(1)" v-show="addFieldnameShow"></i>
                  <i class="el-icon-close" @click="addFieldnamesucc(2)" v-show="addFieldnameShow"></i>
                </span>
              </div>
              <div class="fontback" style="margin-top: 10px;">
                价格字段
              </div>
              <!-- v-show="checkboxShow2[index]" -->
              <div style="margin-left: 20px;margin-top: 10px;">
                <span v-for="(item,index) in orderPrice" :key='index' style="width: 175px;display: inline-block;">
                  <span @mouseover="iconShowTrue2(index,item.fieldRequired)" @mouseout="iconShowFalse2(index,item.fieldRequired)">
                    <el-checkbox :label="item.fieldname" style="margin-bottom: 10px;width: 100px;" v-show="checkboxShow2[index]"
                      :disabled="item.fieldname == '实际销售额' || item.fieldname == '实际销售量' || jbDisabled == 1" v-model="basicField2[index]"  @change="checkboxEmpty2(item.fieldname,index,item.id,item.fieldRequired)"></el-checkbox>
                      <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="fieldname2[index]" maxlength='10' placeholder="请输入内容" size="small" style="width:115px;" v-show="inputShow2[index]"></el-input>
                    <span v-show="iconShow2[index]" style="color: #108cee;cursor: pointer;background-color: white;z-index: 9999;position: absolute;">
   									 <i class="el-icon-edit-outline" style="margin-right: 5px;margin-left: 5px;" v-if="item.fieldname != '申请标价' && item.fieldname != '实际成交价'"
                     @click="InputShow2(index,item.fieldname)"></i>
                     <i class="el-icon-delete" slot="reference" v-if="item.fieldname != '申请标价' && item.fieldname != '实际成交价'"
                     @click="referenceDelete2(index)"></i>
                     <el-popover placement="top" width="200" v-model="popovervisible2[index]">
                      <span><i class="el-icon-warning" style="color: #ffaa16;margin-top: 10px;"></i></span>
                      <span style="margin-left: 9px;color: #585858;font-weight: bold;">你确定要删除该字段吗？</span>
                      </br>
                      <span style="color: #db4757;margin-left: 23px;">删除后录入的信息会被删除</span>
                      <div style="text-align: right; margin-top: 15px;">
                        <el-button type="primary2" size="small" @click="deleteProductField2(index,1,item.id)" style="margin-left: 5px;">确 定</el-button>

                        <el-button size="small" @click="deleteProductField2(index,2)" type="TheCustom">取 消</el-button>
                      </div>
                    </el-popover>
   								  </span>
                    <span v-show="succShow2[index]" style="color: #108cee;cursor: pointer;">
   									  <i class="el-icon-check" style="margin-right: 5px;margin-left: 5px;" @click="productField2(index,1,item.id,item.fieldClassify)"></i>
   									  <i class="el-icon-close" @click="productField2(index,2)"></i>
   								  </span>
                  </span>
                </span>
                <span style="color: #108cee;cursor: pointer;">
                  <i class="el-icon-circle-plus-outline" style="margin-right: 10px;width: 14px;height: 14px;" v-show="addFieldnameHidden2 && jbDisabled == 2" @click="addProductField2()"></i>
                  <span v-show="addFieldnameHidden2 && jbDisabled == 2" @click="addProductField2()">新增</span>
                  <el-input autofocus onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="addFieldname2" maxlength='10' placeholder="请输入内容" size="small" style="width:115px;" v-show="addFieldnameShow2"></el-input>
                  <i class="el-icon-check" style="margin-right: 5px;margin-left: 5px;" @click="addFieldnamesucc2(1)" v-show="addFieldnameShow2"></i>
                  <i class="el-icon-close" @click="addFieldnamesucc2(2)" v-show="addFieldnameShow2"></i>
                </span>
              </div>

            </el-col>
          </el-row>
        </div>
        <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
          <el-button type="primary" @click="wlShow(1)" size="small" style="margin-right: 10px;" v-show="disShow">编 辑</el-button>
          <el-button type="primary2" @click="saveSort" size="small" style="margin-right: 10px;" v-show="nodisShow">确 定</el-button>
          <el-button @click="wlShow(2)" size="small" type="TheCustom" v-show="nodisShow">取 消</el-button>
        </div>
      <!-- 设置表头 -->
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        disShow: true,
        nodisShow: false,
        jbDisabled: 1,
        addFieldname: '',
        addFieldname2: '',
        basicField: [],
        addFieldnameShow: false,
        addFieldnameHidden: true,
        popovervisible: [],
        fieldname: [],
        fieldname2: [],
        orderProduct: [],
        orderPrice: [],
        iconShow2: [],
        inputShow2: [],
        checkboxShow2: [],
        succShow2: [],
        isShow2: [],
        popovervisible2: [],
        basicField2: [],
        keyArray2: [],
        addFieldnameHidden2: true,
        addFieldnameShow2: false,
        ids2: '',
        headerShow: false,
        sigin: false,
        sigin2: false,
        inputShow: [],
        iconShow: [],
        checkboxShow: [],
        succShow: [],
        isShow: [],
        ids: [],
        treeData: [],
        treeData2: [],
      }
    },
    mounted() {
      this.getOrder()
    },
    methods: {
      wlShow(e) {
        if(e == 1) {
          this.disShow = false
          this.nodisShow = true
          this.jbDisabled = 2
          this.addFieldnameHidden = true
          this.addFieldnameHidden2 = true
        } else {
          this.disShow = true
          this.nodisShow = false
          this.jbDisabled = 1
          this.addFieldnameShow = false
          this.addFieldnameShow2 = false
          this.getOrder()
        }
      },
      //确定保存
      saveSort() {
        this.ids = [];
        this.ids2 = [];
        for (var i = 0; i < this.treeData.length; i++) {
          this.ids.push(this.treeData[i].id)
        }
        for (var i = 0; i < this.treeData2.length; i++) {
          this.ids.push(this.treeData2[i].id)
        }
        for (var i = 0; i < this.ids.length; i++) {
          this.ids2 += this.ids[i] + ','
        }
        let params={
          ids: this.ids2,
          module: 'REVIEW',
        }
        fetch({
          url: "hcm/hcmCustomModel/saveSort",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: res.message,
              type: 'success'
            });
            this.headerShow = false
            this.ids = [];
            this.ids2 = [];
            this.getOrder()
            this.disShow = true
            this.nodisShow = false
            this.jbDisabled = 1
            this.addFieldnameShow = false
            this.addFieldnameShow2 = false
          } else {
            this.$message.error(res.message);
          }
        })
      },
      checkboxEmpty(e,f,h,g) {
        if (this.basicField[f] == false) {
          for (var i = 0; i < this.treeData.length; i++) {
            if (this.treeData[i].label == e){
              this.treeData.splice(i, 1);
            }
          }
        } else {
          this.treeData.push(
            {
              id: h,
              label: e,
              fieldRequired: g,
              index: f,
            }
          );
        }
      },
      checkboxEmpty2(e,f,h,g) {
        if (this.basicField2[f] == false) {
          for (var i = 0; i < this.treeData2.length; i++) {
            if (this.treeData2[i].label == e){
              this.treeData2.splice(i, 1);
            }
          }
        } else {
          this.treeData2.push(
            {
              id: h,
              label: e,
              fieldRequired: g,
              index: f,
            }
          );
        }
      },
      empty(e,f) {
        for (var i = 0; i < this.treeData.length; i++) {
          if (this.treeData[i].label == e){
            this.treeData.splice(i, 1);
          }
        }
        this.basicField[f] = false
      },
      empty2(e,f) {
        for (var i = 0; i < this.treeData2.length; i++) {
          if (this.treeData2[i].label == e){
            this.treeData2.splice(i, 1);
          }
        }
        this.basicField2[f] = false
      },
      referenceDelete(e) {
        this.$set(this.popovervisible,e,true);
        this.sigin = true
      },
      referenceDelete2(e) {
        this.$set(this.popovervisible2,e,true);
        this.sigin2 = true
      },
      // 基本字段删除
      deleteProductField(e,f,h) {
        if (f == 1) {
          this.$set(this.popovervisible,e,false);
          this.sigin = false
          let params={
            id: h,
          }
          fetch({
            url: "hcm/hcmCustomModel/delectCampaign",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder()
            } else if (res.status == '10400') {
            }
          })
        } else {
          this.$set(this.popovervisible,e,false);
          this.sigin = false
        }

      },
      // 价格字段删除
      deleteProductField2(e,f,h) {
        if (f == 1) {
          this.$set(this.popovervisible2,e,false);
          this.sigin2 = false
          let params={
            id: h,
          }
          fetch({
            url: "hcm/hcmCustomModel/delectCampaign",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder();
              this.openPhoneShow2 = false
            } else if (res.status == '10400') {
            }
          })
        } else {
          this.$set(this.popovervisible2,e,false);
          this.sigin2 = false
        }
      },
      InputShow(e,f) {
        this.fieldname[e]= f
        this.$set(this.inputShow,e,true);
        this.$set(this.checkboxShow,e,false);
        this.$set(this.isShow,e,true);
        this.$set(this.succShow,e,true);
      },
      InputShow2(e,f) {
        this.fieldname2[e]= f
        this.$set(this.inputShow2,e,true);
        this.$set(this.checkboxShow2,e,false);
        this.$set(this.isShow2,e,true);
        this.$set(this.succShow2,e,true);
      },
      addProductField() {
        this.addFieldnameShow = true
        this.addFieldnameHidden= false
      },
      addProductField2() {
        this.addFieldnameShow2 = true
        this.addFieldnameHidden2= false
      },
      //基本字段确定新增
      addFieldnamesucc(e) {
        if (e==1) {
          if (this.addFieldname == '') {
            this.$message.error('请填写内容');
            return;
          }
          if (isNaN(Number(this.addFieldname)) == false) {
            this.$message.error('自定义字段请勿输入纯数字');
            return;
          }
          this.addFieldnameHidden = true
          this.addFieldnameShow = false
          let params={
            fieldname: this.addFieldname,
            fieldClassify: 'basic',
            module: 'REVIEW',

          }
          fetch({
            url: "hcm/hcmCustomModel/saveCampaign",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.addFieldname = ''
              this.getOrder()
            } else {
              this.$message.error(res.message);
              this.addFieldname = ''
            }
          })
        } else {
          this.addFieldnameHidden = true
          this.addFieldnameShow = false
          this.addFieldname = ''
        }
      },
      //价格字段确定新增
      addFieldnamesucc2(e) {
        if (e==1) {
          if (this.addFieldname2 == '') {
            this.$message.error('请填写内容');
            return;
          }
          if (isNaN(Number(this.addFieldname2)) == false) {
            this.$message.error('自定义字段请勿输入纯数字');
            return;
          }
          this.addFieldnameHidden2 = true
          this.addFieldnameShow2 = false
          let params={
            fieldname: this.addFieldname2,
            fieldClassify: 'PRICE',
            module: 'REVIEW',
          }
          fetch({
            url: "hcm/hcmCustomModel/saveCampaign",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder()
              this.addFieldname2 = ''
            } else {
              this.$message.error(res.message);
              this.addFieldname2 = ''
            }
          })
        } else {
          this.addFieldnameHidden2 = true
          this.addFieldnameShow2 = false
          this.addFieldname2 = ''
        }
      },
      iconShowTrue(e,f) {
        if (f != 1 && this.isShow[e] != true) {
          this.$set(this.iconShow,e,true);
        }
      },
      iconShowFalse(e) {
        if (this.sigin == false) {
          this.$set(this.iconShow,e,false);
        }
      },
      iconShowTrue2(e,f) {
        if (f != 1 && this.isShow2[e] != true) {
          this.$set(this.iconShow2,e,true);
        }
      },
      iconShowFalse2(e) {
        if (this.sigin2 == false) {
          this.$set(this.iconShow2,e,false);
        }
      },
      // 基本字段编辑
      productField(e,f,g,h) {
        if (f == 1) {
          this.$set(this.isShow,e,false);
          this.$set(this.inputShow,e,false);
          this.$set(this.succShow,e,false);
          this.$set(this.checkboxShow,e,true);
          let params={
            id: g,
            fieldname: this.fieldname[e],
            module: 'REVIEW',
            fieldClassify: 'basic',
          }
          fetch({
            url: "hcm/hcmCustomModel/saveCampaign",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder()
              this.fieldname[e] = '';
            } else {
              this.$message.error(res.message);
              this.fieldname[e] = '';
            }
          })
        } else {
          this.$set(this.isShow,e,false);
          this.$set(this.inputShow,e,false);
          this.$set(this.succShow,e,false);
          this.$set(this.checkboxShow,e,true);
        }
      },
      // 价格字段编辑
      productField2(e,f,g,h) {
        if (f == 1) {
          this.$set(this.isShow2,e,false);
          this.$set(this.inputShow2,e,false);
          this.$set(this.succShow2,e,false);
          this.$set(this.checkboxShow2,e,true);
          let params={
            id: g,
            fieldname: this.fieldname2[e],
            module: 'REVIEW',
            fieldClassify: 'PRICE',
          }
          fetch({
            url: "hcm/hcmCustomModel/saveCampaign",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder()
              this.fieldname2[e] = '';
            } else {
              this.$message.error(res.message);
              this.fieldname2[e] = '';
            }
          })
        } else {
          this.$set(this.isShow2,e,false);
          this.$set(this.inputShow2,e,false);
          this.$set(this.succShow2,e,false);
          this.$set(this.checkboxShow2,e,true);
        }
      },
      //获取动态表格
      getOrder() {
        fetch({
          url: "hcm/hcmCustomModel/getListByCampaignReview",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.treeData = [];
            this.treeData2 = [];
            this.orderPrice = [];
            this.orderProduct = [];
            this.basicField = [];
            this.basicField2 = [];
            this.orderPrice = data.price.data;
            this.orderProduct = data.campaign.data;
            for (var i = 0; i < this.orderProduct.length; i++) {
              this.iconShow.push(false)
              this.inputShow.push(false)
              this.checkboxShow.push(true)
              this.succShow.push(false)
              this.isShow.push(false)
              this.popovervisible.push(false)
              if (this.orderProduct[i].isChecked == 1) {
                this.basicField.push(true)
              } else {
                this.basicField.push(false)
              }
              if (this.orderProduct[i].isChecked == 1) {
                this.treeData.push(
                  {
                    id: this.orderProduct[i].id,
                    label: this.orderProduct[i].fieldname,
                    fieldRequired: this.orderProduct[i].fieldRequired,
                    index: i
                  }
                );
              }
            }
            for (var i = 0; i < this.orderPrice.length; i++) {
              this.iconShow2.push(false)
              this.inputShow2.push(false)
              this.checkboxShow2.push(true)
              this.succShow2.push(false)
              this.isShow2.push(false)
              this.popovervisible2.push(false)
              if (this.orderPrice[i].isChecked == 1) {
                this.basicField2.push(true)
              } else {
                this.basicField2.push(false)
              }
              if (this.orderPrice[i].isChecked == 1) {
                this.treeData2.push(
                  {
                    id: this.orderPrice[i].id,
                    label: this.orderPrice[i].fieldname,
                    fieldRequired: this.orderPrice[i].fieldRequired,
                    index: i
                  }
                );
              }
            }
          } else if (res.status == '10400') {

          }
        })
        .catch(err => {

        })
      },
    },
  }
</script>
<style scoped lang="scss">
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
  .page {
    padding: 20px;
    margin: 10px 20px 20px 20px;
    background-color: white;
    min-height: 600px;
  }
  // .headerBorder {
  //   // border: 1px solid #d9d9d9;
  //   height: 450px;
  // }
  .fontback {
    background-color: #f6f7fb;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
  }
</style>
<style lang="scss">
#activityChecking {
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-dialog__title {
    font-size: 14px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
  .el-button--primary2 {
    color: #FFF;
    background-color: #bda571;
    border-color: #bda571;
  }
  .el-button--primary2:hover {
    color: #FFF;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-button--primary2 {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary2:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .w-e-menu{
    z-index: 2 !important;
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
}
</style>
